var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { ChildProperty, Property, Complex, Collection } from '@syncfusion/ej2-base';
import { BackstageBackButton } from './ribbon-back-button';
import { BackstageItem } from './ribbon-backstage-item';
import { RibbonTooltip } from './ribbon-tooltip';
/**
 * Defines the ribbon file menu settings.
 */
export class BackStageMenu extends ChildProperty {
    /**
     * @param {Object} prop - Gets the property of Backstage Menu.
     * @param {boolean} muteOnChange - Gets the boolean value of muteOnChange.
     * @returns {void}
     * @private
     */
    setProperties(prop, muteOnChange) {
        super.setProperties(prop, muteOnChange);
    }
}
__decorate([
    Property('File')
], BackStageMenu.prototype, "text", void 0);
__decorate([
    Property('')
], BackStageMenu.prototype, "keyTip", void 0);
__decorate([
    Property(false)
], BackStageMenu.prototype, "visible", void 0);
__decorate([
    Property('auto')
], BackStageMenu.prototype, "height", void 0);
__decorate([
    Property('auto')
], BackStageMenu.prototype, "width", void 0);
__decorate([
    Property(null)
], BackStageMenu.prototype, "target", void 0);
__decorate([
    Complex({}, BackstageBackButton)
], BackStageMenu.prototype, "backButton", void 0);
__decorate([
    Collection([], BackstageItem)
], BackStageMenu.prototype, "items", void 0);
__decorate([
    Property('')
], BackStageMenu.prototype, "template", void 0);
__decorate([
    Complex({}, RibbonTooltip)
], BackStageMenu.prototype, "ribbonTooltipSettings", void 0);
